/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAmmoLogInfo,
    JsonAmmoLogInfoFromJSON,
    JsonAmmoLogInfoFromJSONTyped,
    JsonAmmoLogInfoToJSON,
} from './JsonAmmoLogInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonAmmoLogInfo
 */
export interface ApiResultOfListOfJsonAmmoLogInfo {
    /**
     * 
     * @type {Array<JsonAmmoLogInfo>}
     * @memberof ApiResultOfListOfJsonAmmoLogInfo
     */
    data?: Array<JsonAmmoLogInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonAmmoLogInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonAmmoLogInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonAmmoLogInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonAmmoLogInfo
     */
    result?: ApiResultOfListOfJsonAmmoLogInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonAmmoLogInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonAmmoLogInfoFromJSON(json: any): ApiResultOfListOfJsonAmmoLogInfo {
    return ApiResultOfListOfJsonAmmoLogInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonAmmoLogInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonAmmoLogInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonAmmoLogInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonAmmoLogInfoToJSON(value?: ApiResultOfListOfJsonAmmoLogInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonAmmoLogInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

